











import { Vue, Component, Prop } from 'vue-property-decorator';
import { IDocumentPage } from '@/types/document-page';
import VideoPlayer from '@/video/player/components/VideoPlayer.vue';
import { IOptionMenuItem } from '@/dealroom/types/option-menu-item';
import { EOptionMenuItemCallback } from '@/dealroom/types/enums/option-menu-item-callback';
import { EFieldOperation } from '@/dealroom/fields/types/enums/field-operation';
import { EDocumentPageType } from '@/enums/document-page-type';

@Component({
  components: {
    VideoPlayer,
  },
})
export default class VideoPage extends Vue {
  @Prop() page!: IDocumentPage;

  currentVideoPlayTime: number = null;
  showOptions = false;

  get options(): IOptionMenuItem[] {
    return [
      {
        icon: 'edit',
        title: this.$t('edit').toString(),
        callback: EOptionMenuItemCallback.Edit,
      },
      {
        icon: 'move',
        title: this.$t('move').toString(),
        callback: EOptionMenuItemCallback.Move,
      },
      {
        icon: 'delete',
        title: this.$t('delete').toString(),
        callback: EOptionMenuItemCallback.Delete,
      },
    ];
  }

  handleDrop(event) {
    const droppedData: string = event.dataTransfer.getData('text');
    if (!droppedData) {
      return;
    }
    this.$emit('fieldRequest', {
      type: EFieldOperation.Create,
      payload: {
        documentPage: {
          pageType: EDocumentPageType.Video,
        },
      },
    });
  }

  handleTimeUpdate(playtime: number): void {
    this.currentVideoPlayTime = playtime;
  }

  handlePause(): void {
    this.sendTrackingData();
  }

  handleEnded(): void {
    this.sendTrackingData();
  }

  handleShowOptions() {
    this.showOptions = true;
  }

  hideOptions() {
    this.showOptions = false;
  }

  sendTrackingData(): void {
    if (!this.currentVideoPlayTime) {
      return;
    }
    this.$emit('trackVideo', { id: this.page.video.id, viewDuration: this.currentVideoPlayTime });
    this.currentVideoPlayTime = null;
  }
}
